// https://date-fns.org/docs/parse
import parseDate from 'date-fns/parse'
// https://date-fns.org/docs/format
import format from 'date-fns/format'
import moment from 'moment'
// import addHours from 'date-fns/add_hours'

const DATE_TIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSZZ'

export default function formatDate(date) {
  date = parseDate(date)
  // return format(addHours(date, -3), 'YYYY-MM-DD HH:mm:ss')
  return format(date, 'YYYY-MM-DD HH:mm:ss')
}

export function convertToUTC(dateTime, format) {
  return moment(dateTime)
    .utc()
    .format(format || DATE_TIME_FORMAT)
}
